// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"96":"vendors","470":"settings-vendors"}[chunkId] + "-" + {"96":"34dccbd3e71683757bb0","470":"c4180bf351439fa4732c"}[chunkId] + ".js";
};